import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function useEnarmCountdown() {
  const calculateTime = () => {
    // ENARM 2026: 28 de Septiembre de 2026, 08:00 AM CDMX (-06:00)
    const target = new Date('2026-09-28T08:00:00-06:00').getTime();
    const now = Date.now();
    const diff = Math.max(0, target - now);

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return timeLeft;
}

export function EnarmCountdownBanner() {
  const { days, hours, minutes, seconds } = useEnarmCountdown();

  return (
    <aside aria-label="Cuenta regresiva ENARM 2026" className="relative z-50 border-b border-emerald-500/30 bg-gradient-to-r from-emerald-950 via-slate-950 to-emerald-950 px-3 py-2 text-xs text-white sm:text-sm">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 sm:flex-nowrap">
        {/* Left side: Countdown */}
        <div className="flex items-center gap-2 font-medium">
          <span className="flex h-2 w-2 rounded-full bg-emerald-400 animate-ping" />
          <span className="text-[11px] font-black uppercase tracking-wider text-emerald-400 sm:text-xs">
            ENARM 2026 · 28 Septiembre
          </span>
          <span className="hidden text-white/30 sm:inline">|</span>
          <span className="text-white/80 hidden xs:inline text-xs">
            Faltan:
          </span>
          <div className="inline-flex items-center gap-1 font-mono font-bold text-emerald-300">
            <span className="rounded border border-emerald-700/50 bg-emerald-900/60 px-1.5 py-0.5 text-xs sm:text-sm">{days}d</span>
            <span>:</span>
            <span className="rounded border border-emerald-700/50 bg-emerald-900/60 px-1.5 py-0.5 text-xs sm:text-sm">{String(hours).padStart(2, '0')}h</span>
            <span>:</span>
            <span className="rounded border border-emerald-700/50 bg-emerald-900/60 px-1.5 py-0.5 text-xs sm:text-sm">{String(minutes).padStart(2, '0')}m</span>
            <span className="hidden sm:inline">:</span>
            <span className="hidden rounded border border-emerald-700/50 bg-emerald-900/60 px-1.5 py-0.5 text-xs sm:inline sm:text-sm">{String(seconds).padStart(2, '0')}s</span>
          </div>
        </div>

        {/* Right side: Free Trial & Ruta Selecta CTA */}
        <div className="flex items-center gap-2 text-[11px] sm:text-xs">
          <span className="hidden text-emerald-200/90 md:inline font-medium">
            📚 Estudia estos últimos días con nuestros mazos: <strong className="text-white font-bold">Ruta Selecta</strong> y <strong className="text-amber-300 font-bold">Ruta Selecta Exprés</strong>
          </span>
          <Link
            to="/planes"
            className="inline-flex items-center gap-1 rounded-full bg-emerald-400 px-3 py-1 text-[11px] font-black text-slate-950 shadow-sm shadow-emerald-500/50 transition-all hover:bg-emerald-300 hover:scale-105"
          >
            <span>3 Días de Prueba Gratis</span>
            <ArrowRight className="h-3 w-3" />
          </Link>
        </div>
      </div>
    </aside>
  );
}
